import React, { Component } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { withNamespaces } from "react-i18next";
import Lightbox from "react-image-lightbox";
import moment from "moment";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import MemberRegisterOriginListing from "./MemberRegisterOriginListing";
import MemberRegisterOriginDetail from "./MemberRegisterOriginDetail";

import { getMemberRegisterOrigin } from "../../store/ducks/memberRegisterOrigin/actions";
import { filterErrorHandler } from "../../hoc/Shared/utility";

const initialInputState = {
    /* form input value */
    register_origin: "",
};

let memberLoginStatusData = {};
class MemberRegisterOrigin extends Component {
    state = {
        pageShow: "listing",

        activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
        limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
        sorted: null,
        totalPages: 0,
        totalRecords: 0,
        searchValue: "",
        isOpen: false,

        data: [],
        collidedIPData: [],

        dropDown: [],

        filter: initialInputState,

        currentBusinessAccountId: "",
        loading: true,
        currentImage: "",
        detailsParam: {},

        permission: [],
    };

    fetchData() {
        let availablePage = this.state.activePage;

        if (this.state.totalRecords !== 0) {
            availablePage = parseInt(this.state.totalRecords / this.state.limit + 1);
            this.state.activePage >= availablePage && this.setState({ activePage: availablePage });
        }
        Object.keys(this.state.filter).forEach((val) =>
        {
            // listingArr[val] = this.state.filter[val];
            memberLoginStatusData[val] = ((val==='start_date' || val==='end_date') && this.state.filter[val]!=='') ? moment(this.state.filter[val]).format("YYYY-MM-DD HH:mm:ss") : this.state.filter[val];
        });
        memberLoginStatusData.page = this.state.activePage >= availablePage ? availablePage : this.state.activePage;
        memberLoginStatusData.limit = this.state.limit;
        memberLoginStatusData.order = JSON.stringify(this.state.sorted);
        memberLoginStatusData.lang_id = this.props.currentLanguageId;
        memberLoginStatusData.title = this.state.filter.title;
        memberLoginStatusData.status = this.state.filter.status;
        memberLoginStatusData.country_id = this.props.currentCountryId;

        this.props.getMemberRegisterOrigin(memberLoginStatusData);
    }

    componentDidMount() {
        this.fetchData();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.permission.length === 0 && this.props.currentPermission !== undefined) {
            let promotionPermission = this.props.currentPermission.filter((item) => item.includes("member_register_origin_"));
            this.setState({ permission: promotionPermission });
        }

        if (nextProps.member_register_origin_data !== this.props.member_register_origin_data) {
            if (nextProps.member_register_origin_data.data.responseCode === 200) {
                this.setState({
                    loading: false,
                    data: nextProps.member_register_origin_data.data.data.row,
                    totalRecords: nextProps.member_register_origin_data.data.data.pagination.total_record,
                    totalPages: nextProps.member_register_origin_data.data.data.pagination.total_page,
                });
            } else {
                this.setState({
                    loading: false,
                    totalPages: 0,
                    activePage: 1,
                    totalRecords: 0,
                    data: []
                }, () => 
                {
                    filterErrorHandler(nextProps.member_register_origin_data.data.message);
                });
            }
        }

        return true;
    }

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence;

        if (order === "asc") {
            orderSequence = true;
        } else {
            orderSequence = false;
        }

        orderArry[0]["id"] = field;
        orderArry[0]["desc"] = orderSequence;

        this.setState({ sorted: orderArry, loading: true, data: [] }, () => {
            this.fetchData();
        });
    };

    updateStatusPromotionHandler = (event, promotionId) => {
        event.preventDefault();
        Swal.fire({
            title: "",
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            onOpen: () => {
                Swal.showLoading();
            },
        });

        const updatePromotionStatusData = {};
        updatePromotionStatusData.video_id = promotionId;
        updatePromotionStatusData.status = Number(event.target.value);

        this.props.updatePromotedVideoStatus(updatePromotionStatusData);
    };

    updateShowPromotionHandler = (event, promotionId) => {
        event.preventDefault();
        Swal.fire({
            title: "",
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            onOpen: () => {
                Swal.showLoading();
            },
        });
        const updatePromotionShowData = {};
        updatePromotionShowData.promotion_id = promotionId;
        updatePromotionShowData.show = Number(event.target.value);

        this.props.updatePromotionShow(updatePromotionShowData);
    };

    onInputChange(event) {
        let newFilter = Object.assign({}, this.state.filter);
        newFilter[event.target.id] = event.target.value;

        if(event.target.id==='member_login_date')
        {
            const date = (event.target.value!=='') ? event.target.value.split(" - ") : null;
            newFilter['start_date'] = (date) ? date[0] : '';
            newFilter['end_date'] = (date) ? date[1] : '';
        }

        this.setState({
            filter: newFilter,
        });
    }

    refreshHandler = () => {
        this.setState(
            {
                loading: true,
                data: [],
                activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
                limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
                sorted: null
            },
            () => {
                this.fetchData();
            }
        );
    };

    clearHandler = () => {
        this.setState(
            {
                activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
                limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
                filter: initialInputState,
                loading: true,
                data: [],
                sorted: null
            },
            () => {
                this.fetchData();
            }
        );
    };

    changePageHandler = (page, businessAccountId) => {
        this.setState({
            pageShow: page,
            currentBusinessAccountId: businessAccountId,
        });
    };

    pageChangeHandler = (activePage) => {
        this.setState({ page: activePage, activePage: activePage, loading: true, data: [] }, () => {
            this.fetchData();
        });
    };

    sizePerPageHandler = (limit) => {
        this.setState({ limit: limit, loading: true, data: [] }, () => {
            this.fetchData();
        });
    };

    postSearchHandler = () => {
        this.setState({ loading: true, data: [], activePage: 1 }, () => {
            this.fetchData();
        });
    };

    onSearchKeyPressHandler = (event) => {
        //Checking press the enter only perform search action
        if (event.key === "Enter") {
            this.setState({ loading: true, data: [], activePage: 1 }, () => {
                this.fetchData();
            });
        }
    };

    actionFormatter = (cell, row) => {

        let output;

        output = (<b>
            <a href="/#" onClick={(event) => this.detailsHandler(event, row.register_origin)}>
                {row.total}
                <i className="fas fa-external-link-square-alt text-primary ml-1"></i>
            </a>
        </b>);
        return output;
    };

    detailsHandler = (e, registerOrigin) => {
        e.preventDefault();
        this.setState({
            pageShow: 'details',
            detailsParam : {
                registerOrigin: registerOrigin,
                returnPage: 'listing'
            }
        });
    }

    render() {
        const { t } = this.props;
        const columns = [
            {
                text: t("global.no"),
                dataField: "",
                keyField: "ipId",
                formatter: (cell, row, rowIndex) => {
                    //let rowNumber = (this.state.activePage - 1) * this.state.limit + (rowIndex + 1);
                    let reverseRowNumber = this.state.totalRecords - rowIndex - (this.state.activePage - 1) * this.state.limit;
                    return <span>{reverseRowNumber}</span>;
                },
                headerStyle: () => {
                    return { width: "60px" };
                },
            },
            {
                text: t("member-register-origin.register-origin"),
                dataField: "register_origin",
                keyField: "register_origin",
                sort: true,
                onSort: this.onSort,
                // hidden: true
            },
            {
                text: t("member-register-origin.total"),
                dataField: "total",
                keyField: "total",
                sort: true,
                onSort: this.onSort,
                formatter: this.actionFormatter
            },
        ];

        return (
            <Auxiliary>
                {this.state.pageShow === "listing" && (
                    <div>
                        {this.state.isOpen && <Lightbox mainSrc={this.state.currentImage} onCloseRequest={() => this.setState({ isOpen: false })} />}
                        <div className="breadcrumb-header justify-content-between">
                            <div className="my-auto">
                                <div className="d-flex">
                                    <h4 className="text-muted mt-1 tx-13 ml-2 mb-0">{t("member-register-origin.member-register-origin")}</h4>
                                </div>
                            </div>
                        </div>

                        <MemberRegisterOriginListing
                            register_origin={this.state.filter.register_origin}
                            onInputChange={(event) => this.onInputChange(event)}
                            clearHandler={() => this.clearHandler()}
                            refreshHandler={() => this.refreshHandler()}
                            columns={columns}
                            activePage={this.state.activePage}
                            limit={this.state.limit}
                            totalRecords={this.state.totalRecords}
                            data={this.state.data}
                            order={this.state.sorted}
                            pageChangeHandler={this.pageChangeHandler}
                            sizePerPageHandler={this.sizePerPageHandler}
                            postSearchHandler={this.postSearchHandler}
                            searchPressSubmitHandler={(event) => this.onSearchKeyPressHandler(event)}
                            loading={this.state.loading}
                            permission={this.state.permission}
                            ddBankName={this.state.dropDown.bank_name}
                        />
                    </div>
                )}

                {this.state.pageShow === "details" &&
                    <MemberRegisterOriginDetail 
                        detailsParam={this.state.detailsParam}
                        changePageHandler={(page) => this.changePageHandler(page)}
                    />
                }

                {/* {this.state.pageShow === "create" && (
                    <PromotedVideoCreate refreshHandler={() => this.refreshHandler()} changePageHandler={(page) => this.changePageHandler(page)} />
                )}

                {this.state.pageShow === "show" && (
                    <PromotedVideoShow show_video_id={this.state.currentPromotedVideoId} changePageHandler={(page) => this.changePageHandler(page)} />
                )}
                */}

                {/* {this.state.pageShow === "edit" && (
                    <BusinessAccountEdit
                        show_business_account_id={this.state.currentBusinessAccountId}
                        refreshHandler={() => this.refreshHandler()}
                        changePageHandler={(page) => this.changePageHandler(page)}
                    />
                )}  */}
            </Auxiliary>
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = (state) => {
    const { currentUser, memberRegisterOrgin } = state;

    return {
        currentCountryId: currentUser.data.country_id,
        currentLanguageId: currentUser.data.language_id,
        currentPermission: currentUser.data.permission,
        member_register_origin_data: memberRegisterOrgin.member_register_origin_data
    };
};

const mapDispatchToProps = {
    getMemberRegisterOrigin
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(MemberRegisterOrigin));
